import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SnotifyService } from "ng-snotify";
import { CompanyService } from "../../../../services/company.service";
import { LocationService } from "../../../../services/location.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "../../../../services/auth.service";
import { UUID } from "angular2-uuid";
import { Location } from '../../../../models/location'


@Component({
  selector: 'app-locations-manage',
  templateUrl: './locations-manage.component.html',
  styleUrls: ['./locations-manage.component.scss']
})
export class LocationsManageComponent implements OnInit {

  id;
  location: Location;
  user;
  company_Id;

  isEdit: boolean = false;
  expired: boolean = false;
  constructor(private authService: AuthService, private sanitizer: DomSanitizer, private locationService: LocationService, private companyService: CompanyService,
    private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService) {
    this.user = this.authService.currentUser.value;
    this.location = new Location;
  }

  ngOnInit(): void {
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["company_Id"];
    this.id = this.router.parseUrl(this.router.url).queryParams["id"];
    //console.log(this.id);
    if (this.id != null) {

      this.locationService.getById(this.id).then((loc) => {
        //console.log(loc);
        this.location = loc;

        this.isEdit = true;
      });
    } else {
      this.isEdit = false;
    }

  }



  back() {
    this.router.navigate(['admin/locations'], { queryParams: { id: this.company_Id } });
  }

  validate() {
    if (this.location.name == null || this.location.name == "") {
      this.snotifyService.error("Enter name of this location");
      return false;
    }
    if (this.location.address_1 == null || this.location.address_1 == "") {
      this.snotifyService.error("Enter address 1");
      return false;
    }
    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }


    this.location.companyId = this.company_Id;
    //console.log(this.id);
    if (this.id == null)
      await this.locationService.add(this.location);
    else
      await this.locationService.update(this.location);

    this.back();
  }

  async delete() {
    await this.locationService.delete(this.id);
    this.back();
  }


}
